import React, { FC, ReactNode, useRef, useState } from 'react'
import {
	ButtonComponent,
	DynamicAgreement,
	ModalComponent,
	SubmitComponent,
} from 'Pages/landings/newLandings/common/components'
import { OrderCreateParamsWithFile } from 'Pages/landings/newLandings/common/types'
import { useForm } from 'Pages/landings/newLandings/common/hooks'
import { FieldNames } from 'Pages/landings/newLandings/common/constants'
import {
	required,
	validateCyrillicsWithHyphen,
	validateInn,
	validatePhone,
} from 'Pages/landings/newLandings/common/validators'
import { normalizePhone } from 'Pages/landings/newLandings/common/helpers'
import { InnFormComponent } from 'Pages/landings/newLandings/products/rboPage/ModalnnForm'
import { Wrapper, Input, InnBlock, InnInput, SubmitBlock } from './styled'

interface ComponentProps {
	children: ReactNode
	isInn?: boolean
	isKnowInn?: boolean
	isProduct?: boolean
	btnType?: string
	wrapperMB?: number
	linkColor?: string
	isLoading?: boolean
	changeLoading?: () => void
	icon?: JSX.Element
	isLastName?: boolean
}

export const FormModelComponent: FC<ComponentProps> = ({
	children,
	isInn = false,
	isKnowInn = false,
	isProduct = false,
	btnType = 'primary',
	linkColor,
	wrapperMB,
	isLoading = false,
	changeLoading,
	icon,
	isLastName = false,
}) => {
	const {
		formValue,
		createChangeHandler,
		getFormError,
		getFormValue,
		submit,
		setFormValue,
		clearForm,
	} = useForm<OrderCreateParamsWithFile>()
	const orderID = useRef<number | null>(null)
	const needConfirmPhone = useRef<boolean | null>(null)
	const [isShowModal, setIsShowModal] = useState(false)
	const changeShowModal = () => setIsShowModal(!isShowModal)
	const btnText = isLoading ? 'Идет отправка' : 'Оставить заявку'

	const onInnFormSet = (inn: string, lastName: string, firstName: string) => {
		setFormValue({
			...formValue,
			[FieldNames.INN]: inn,
			[FieldNames.LAST_NAME]: lastName,
			[FieldNames.FIRST_NAME]: firstName,
		})
		changeShowModal()
	}

	const goBack = () => {
		clearForm()
	}

	return (
		<Wrapper marginBottom={wrapperMB}>
			{children}
			<Input
				onChange={createChangeHandler({
					fieldName: FieldNames.FIRST_NAME,
					validation: [required(), validateCyrillicsWithHyphen()],
					initialValue: '',
				})}
				type="text"
				placeholder="Введите имя"
				name={FieldNames.FIRST_NAME}
				measure="l"
				value={getFormValue(FieldNames.FIRST_NAME)}
				error={getFormError(FieldNames.FIRST_NAME)}
			/>
			{isLastName && (
				<Input
					onChange={createChangeHandler({
						fieldName: FieldNames.LAST_NAME,
						validation: [required(), validateCyrillicsWithHyphen()],
						initialValue: '',
					})}
					type="text"
					placeholder="Введите фамилию"
					name={FieldNames.LAST_NAME}
					measure="l"
					value={getFormValue(FieldNames.LAST_NAME)}
					error={getFormError(FieldNames.LAST_NAME)}
				/>
			)}
			<Input
				onChange={createChangeHandler({
					fieldName: FieldNames.PHONE,
					validation: [required(), validatePhone()],
					initialValue: '',
					normalize: normalizePhone,
				})}
				placeholder="Укажите номер телефона"
				type="text"
				mask="+7 (999) 999-99-99"
				maskChar="_"
				input="phone"
				name={FieldNames.PHONE}
				measure="l"
				value={getFormValue(FieldNames.PHONE)}
				error={getFormError(FieldNames.PHONE)}
			/>
			{isInn && !isKnowInn ? (
				<Input
					onChange={createChangeHandler({
						fieldName: FieldNames.INN,
						validation: [required(), validateInn()],
						initialValue: '',
					})}
					placeholder="Введите ИНН"
					type="text"
					name={FieldNames.INN}
					measure="l"
					value={getFormValue(FieldNames.INN)}
					error={getFormError(FieldNames.INN)}
				/>
			) : null}
			{isInn && isKnowInn ? (
				<InnBlock>
					<InnInput
						onChange={createChangeHandler({
							fieldName: FieldNames.INN,
							validation: [required(), validateInn()],
							initialValue: '',
						})}
						placeholder="Введите ИНН"
						type="text"
						name={FieldNames.INN}
						measure="l"
						value={getFormValue(FieldNames.INN)}
						error={getFormError(FieldNames.INN)}
						icon={icon}
					/>
					<ButtonComponent
						type="secondary"
						measure="l"
						text="Узнать ИНН"
						onClick={() => changeShowModal()}
					/>
				</InnBlock>
			) : null}
			{isShowModal && (
				<ModalComponent
					isScroll={isShowModal}
					closeModal={changeShowModal}
					title="Узнайте свой ИНН"
					hiddenBtn
				>
					<InnFormComponent
						item={{
							firstName: formValue[FieldNames.FIRST_NAME],
							lastName: formValue[FieldNames.LAST_NAME],
						}}
						callbackSetInn={onInnFormSet}
						closeModal={changeShowModal}
					/>
				</ModalComponent>
			)}
			<SubmitBlock>
				<DynamicAgreement
					orderID={orderID}
					linkColor={linkColor}
					btnType={btnType}
					needConfirmPhone={needConfirmPhone}
				/>
				<SubmitComponent
					type={btnType}
					measure="l"
					text={btnText}
					formValue={formValue}
					submit={submit}
					orderID={orderID.current}
					isProduct={isProduct}
					goBack={goBack}
					needConfirmPhone={needConfirmPhone.current}
					changeLoading={changeLoading}
					isLoading={isLoading}
				/>
			</SubmitBlock>
		</Wrapper>
	)
}
